module.exports = __webpack_public_path__ + "img/construction.ae5ef2c6.png";